import guestAxios from "@/utils/guestAxios";

export const guestHotelServicesApi = {
  getAll: ({ categoryId, isAvailable = true } = {}) =>
    guestAxios.get("/api/guest-portal/hotel-services", {
      params: {
        categoryId,
        isAvailable,
      },
    }),
};
